<template>
  <div
    :class="['info-title', { 'info-title-2': !buttonText }]"
    @click="handleClick"
  >
    <h2 class="title">{{ title }}</h2>
    <a-button class="change-button" v-show="buttonText" :disabled="disabled">{{
      buttonText
    }}</a-button>
  </div>
</template>

<script>
export default {
  name: "InfoTitle",
  props: {
    title: {
      default: function () {
        return ''
      }
    },
    buttonText: {
      default: function () {
        return ''
      }
    },
    fn: {
      default: function () {
        return () => { }
      }
    },
    disabled: Boolean
  },
  methods: {
    handleClick() {
      if(this.fn && !this.disabled) {
        this.fn(true);
      }
    }
  }
}
</script>

<style scoped>
.info-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-title-2 {
  justify-content: flex-start;
}

.info-title .title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  line-height: 17px;
}

.info-title .change-button {
  height: 25px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border-color: #e5e5e7;
  text-align: center;
  line-height: 23px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(101, 102, 103, 1);
  cursor: pointer;
}

.change-button:hover,
.change-button:focus {
  border-color: #d8d9da;
}
</style>
